import React from "react";
import FreqLoader from "@/components/FreqLoader";

// Brand loading state — the "Tuning frequencies…" pulse used on app boot and page loads.
export const TuningLoader = ({ full = false }) => (
  <div className={`${full ? "min-h-screen bg-black" : "min-h-[40vh]"} flex flex-col items-center justify-center gap-3`} data-testid="tuning-loader">
    <FreqLoader size={28} className="text-[#FF4500]" />
    <div className="text-zinc-500 text-sm font-display tracking-widest uppercase animate-pulse">
      Tuning frequencies…
    </div>
  </div>
);
